import { getEndPoint } from './getEndPoint'
export const getMedia = id => getEndPoint('wp/v2/media/' + id)
